// extracted by mini-css-extract-plugin
module.exports = {"className":"ja-JP_className__1sJhL"};